"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsoluteOverlay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Spinner_1 = require("./Spinner");
var utils_1 = require("utils");
var ABSOLUTE_OVERLAY_STYLES = "flex h-full w-full absolute top-0 left-0 bg-opacity-75 z-30";
var AbsoluteOverlay = function (_a) {
    var bgClassName = _a.bgClassName;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, utils_1.concatStyles)(ABSOLUTE_OVERLAY_STYLES, bgClassName !== null && bgClassName !== void 0 ? bgClassName : "bg-white") }, { children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { size: "4x", className: "m-auto" }, void 0) }), void 0));
};
exports.AbsoluteOverlay = AbsoluteOverlay;
